import { render, staticRenderFns } from "./ItemSidebar.vue?vue&type=template&id=f36d4148"
import script from "./ItemSidebar.vue?vue&type=script&lang=js"
export * from "./ItemSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports